const renderCredit = credits => credits.map(credit => (
  `${credit.hours.toFixed(2)} ${credit.typeName.trim()}`
)).join(', ');

export default renderCredit;
